import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {NAVIGATION_PAGES} from '../../domain/navigation-pages';
import {AuthService} from '../../../infrastructure/auth/auth.service';
import {UserService} from '../../../infrastructure/auth/user.service';
import {User} from '../../../infrastructure/auth/user';
import {ToolbarService} from '../../service/toolbar.service';
import {MatDialog} from '@angular/material/dialog';
import {GeneralSearch} from '../../../modules/general_search/domain/general-search';
import {NgbDropdown} from '@ng-bootstrap/ng-bootstrap';
import {GeneralSearchService} from '../../../modules/general_search/service/general-search.service';
import {Router} from '@angular/router';
import {AppNotification, AppNotificationType} from '../../../modules/core/notification/domain/notification';
import {NotificationService} from '../../service/notification.service';
import {WebSocketService, WebSocketServiceInstance} from '../../../infrastructure/service/web-socket.service';
import {WebSocketHandler} from '../../../infrastructure/service/web-socket-handler';
import {SnackbarService} from '../../../infrastructure/service/snackbar.service';
import {WSMessage} from '../../../infrastructure/domain/ws-message';
import {TermsDialogComponent} from './terms-dialog/terms-dialog.component';
import {MobileGeneralSearchDialogComponent} from './mobile-general-search-dialog/mobile-general-search-dialog.component';
import {MobileNotificationsDialogComponent} from './mobile-notifications-dialog/mobile-notifications-dialog.component';
import {environment} from '../../../../environments/environment';


@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit, OnDestroy, WebSocketHandler {

  public focus = false;
  readonly navigationPages = NAVIGATION_PAGES;

  private topic = '/notification';
  private websocketInstance!: WebSocketServiceInstance;
  notifications: AppNotification[] = [];
  isAdmin = false;

  @Input()
  snav: any;

  @Input()
  sidenav: any;

  user!: User;

  /* userTenants!: UserTenant[]; */

  @Output()
  changeTenantOptionsEvent = new EventEmitter();

  // General Search
  generalSearchOptions!: GeneralSearch[];

  filterText = '';

  @ViewChild('generalSearchDropdown', { read: NgbDropdown })
  public generalSearchDropdown!: NgbDropdown;

  filterChangeTimeout: any;
  filterChangeSecondsInterval = 300;

  readTimer: any;

  constructor(private authService: AuthService,
    private userService: UserService,
    private toolbarService: ToolbarService,
    private notificationService: NotificationService,
    private snackbarService: SnackbarService,
    private websocket: WebSocketService,
    public dialog: MatDialog,
    private router: Router,
    private generalSearchService: GeneralSearchService) {
  }

  ngOnInit(): void {
    this.notificationService.findAll().then(n => this.notifications = n);
    this.websocketInstance = this.websocket.connect(this.topic, this);

    this.user = this.userService.loadLocalUser() || { id: '', name: '' };

    this.authService.checkCredentials().then(auth => {
      if (auth) {
        this.isAdmin = !!this.userService.loadLoggedUserTenant()?.user?.admin;
        this.userService.getLoggedUser().then((u) => {
          this.user = u;

          if (!u.termIsAccepted) {
            const dialogRef = this.dialog.open(TermsDialogComponent, {
              disableClose: true,
              closeOnNavigation: false,
              width: '600px',
              data: {
                termVersion: u.termVersion,
                termContent: u.termContent
              }
            });

            dialogRef.afterClosed().subscribe(accepted => {
              if (accepted === true) {
                this.userService.acceptTerms().then(res => {
                  this.user = res;
                  this.snackbarService.success('Termo aceito com sucesso!');
                  this.redirectAfterTermsAcceptance();
                })
                  .catch(err => {
                    this.snackbarService.error('erro ao aceitar termo');

                  });
              } else if (accepted === false) {
                this.snackbarService.error('Você precisa aceitar os termos para utilizar o sistema.');
                this.authService.logout();
              }
            });
          }



        });
      }
    });

  }

  ngOnDestroy(): void {
    this.websocketInstance.disconnect();

    // this.routeSub.unsubscribe();
  }

  handleMessage(message: WSMessage): void {
    const item: AppNotification = JSON.parse(message.object);

    const idx = this.notifications.findIndex(n => n.id === item.id);
    if (idx !== -1) {
      this.notifications[idx] = item;
    } else {
      this.notifications.unshift(item);
    }

    this.handleBrowserNotification(item);

    const description = item.description.length < 100 ? item.description : item.description + '...';

    switch (item.type) {
      case AppNotificationType.SUCCESS:
        this.snackbarService.success(description);
        break;
      case AppNotificationType.ERROR:
        this.snackbarService.error(description);
        break;
      case AppNotificationType.WARNING:
        this.snackbarService.warning(description);
        break;
      case AppNotificationType.INFORMATION:
        this.snackbarService.info(description);
        break;
      default:
        this.snackbarService.info(description);
    }

    this.notifications = this.notifications.sort((a: AppNotification, b: AppNotification) => this.getNotificationTime(b) - this.getNotificationTime(a));
  }

  /* showTenantOptions(): void {
    const dialogRef = this.dialog.open(SwitchTenantComponent, {
      data: this.userTenants,
      // position: position,
      // height: '100vh'
    });
  } */

  logout(): void {
    this.authService.logout();
  }

  getTitle(): string {
    return this.toolbarService.getTitle() || '';
  }
  getTitleIcon(): string { return this.toolbarService.getTitleIcon(); }

  getToolbar(): any[] {
    return this.toolbarService.getToolbar();
  }

  executeCallback(callback: any, params: any): void {
    this.toolbarService.executeCallback(callback, params);
  }

  openMobileGeneralSearch(): void {
    this.dialog.open(MobileGeneralSearchDialogComponent, {
      panelClass: 'mobile-navbar-dialog',
      width: '100vw',
      height: '100dvh',
      maxWidth: '100vw',
      maxHeight: '100dvh'
    });
  }

  openMobileNotifications(): void {
    this.dialog.open(MobileNotificationsDialogComponent, {
      panelClass: 'mobile-navbar-dialog',
      width: '100vw',
      height: '100dvh',
      maxWidth: '100vw',
      maxHeight: '100dvh',
      data: { notifications: this.notifications }
    });
  }

  generalSearchInput(event: any): void {
    clearTimeout(this.filterChangeTimeout);
    if (event.target.value !== '') {
      this.filterChangeTimeout = setTimeout(() => {
        this.search(event.target.value);

      }, this.filterChangeSecondsInterval
      );
    } else {
      this.generalSearchDropdown.close();
    }
  }

  search(texto: string): void {
    if (texto !== '') {
      this.generalSearchService.findByText(texto).then(generalSearchs => {
        this.generalSearchOptions = generalSearchs;
        this.generalSearchDropdown.open();

      }).catch(err => console.log('ERRO: ', JSON.stringify(err)));
    } else {
      this.generalSearchOptions = [];
    }
  }

  generalSearchFocus(focus: boolean): void {
    this.focus = focus;
    if (!focus) {
      this.filterText = '';
    }
  }

  generalSearchChange(event: any): void {
    event.target.value = '';
  }

  hasUnreadNotification(): boolean {
    return this.notifications.some(n => !n.read);
  }

  startReadTimer(notification: AppNotification): void {
    this.cancelReadTimer();
    this.readTimer = setTimeout(() => this.markAsRead(notification), 2000);
  }

  markAsRead(notification: AppNotification): void {
    if (!notification.read) {
      this.notificationService.markAsRead(notification.id).then(() => {
        notification.read = true;
        const idx = this.notifications.findIndex(n => n.id === notification.id);
        this.notifications[idx] = notification;
        this.notifications = [...this.notifications];
      });
    }
  }

  cancelReadTimer(): void {
    clearTimeout(this.readTimer);
  }

  readAndRedirect(notification: AppNotification): void {
    this.markAsRead(notification);
    if (notification.link) {
      this.router.navigateByUrl(notification.link);
    }
  }

  openNotifications(notification?: AppNotification, event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();
    if (notification) {
      this.markAsRead(notification);
      this.router.navigate(['/notifications'], { fragment: `notification-${notification.id}` });
      return;
    }
    this.router.navigate(['/notifications']);
  }

  openAdminNotifications(event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();
    this.router.navigate(['/notifications/admin']);
  }

  getNotificationPreview(notification: AppNotification): string {
    return notification.description
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<[^>]+>/g, '')
      .replace(/&nbsp;/gi, ' ')
      .trim();
  }

  shouldShowFullNotificationLink(notification: AppNotification): boolean {
    const preview = this.getNotificationPreview(notification);
    const lineBreakCount = (preview.match(/\n/g) || []).length;
    return lineBreakCount >= 5 || preview.length > 360;
  }

  markAllAsRead(): void {
    this.notificationService.markAllAsRead().then(() => {
      this.notifications.forEach(n => n.read = true);
      this.notifications = [...this.notifications];
    });
  }

  private redirectAfterTermsAcceptance(): Promise<boolean> {
    return this.router.navigate(['/dashboard']);
  }

  generalSearchEnter(event: any): void {
    event.preventDefault();

    const generalSearchWithLinks = this.generalSearchOptions.filter(g => g.generalEntity.length > 0);
    if (generalSearchWithLinks.length >= 1) {
      this.router.navigate(['/', this.generalSearchOptions[0].route, this.generalSearchOptions[0].generalEntity[0].id]);
    }
  }

  handleBrowserNotification(appNotification: AppNotification): void {

    if (Notification.permission === 'granted') {
      const notification = new Notification(appNotification.title, {
        body: appNotification.description,
        data: { link: appNotification.link }
      });

      notification.onclick = () => {
        this.router.navigate([notification.data.link]);
      };
    } else if (Notification.permission !== 'denied') {
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          const notification = new Notification(appNotification.title, {
            body: appNotification.description,
            data: { link: appNotification.link }
          });

          notification.onclick = () => {
            this.router.navigate([notification.data.link]);
          };
        }
      });
    }

  }

  updatePasswordAndRedirect(/* event: any */): void {
    //event.preventDefault(); // Impede o comportamento padrão do link

    // Obtém a URL atual da página (sem o fragmento da URL)

    //remover hash '#'
    const currentUrl = window.location.origin + window.location.hash.replace('#', '');
    //const currentUrl = window.location.href;

    /* alert(window.location.origin)
    alert(window.location.pathname)

    alert(window.location.origin + window.location.hash.replace('#', '')); */



    // URL base e parâmetros fixos
    const baseUrl = `${environment.oauth2Url}/protocol/openid-connect/auth`;
    const params = new URLSearchParams({
      client_id: 'account-console',
      redirect_uri: encodeURIComponent(currentUrl), // Usando a URL atual como redirect_uri
      state: 'ef7e509a-e7f1-48e0-83a3-7b40a3121ea0',
      response_mode: 'fragment',
      response_type: 'code',
      scope: 'openid',
      nonce: '70fe9634-2058-41b9-aa20-9306453a371c',
      kc_action: 'UPDATE_PASSWORD',
      code_challenge: '-zdEnfomnHa8BR9zieJE5aB7sk1ul7dpZp1NeDaA4rk',
      code_challenge_method: 'S256',
    });

    const redirectUrl = `${baseUrl}?${params.toString()}`;

    // Redireciona para a URL gerada
    if ((window as any).__karma__) {
      return;
    }
    window.location.href = redirectUrl;
  }

  private getNotificationTime(notification: AppNotification): number {
    return new Date(notification.updated || notification.created || 0).getTime();
  }


}
